<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="usersList"
      :search="search"
      sort-by="token"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Log listesi</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Veri Ara"
            single-line
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
         
        </v-toolbar>
      </template>
    </v-data-table>
  </div>
</template>
<script>
export default {
  data() {
    return {
      id: this.$route.params.id,
      tokenStatus: true,
      dialog: false,
      search: "",
      headers: [
        { text: "Log ID", value: "_id" },
        { text: "Tarih", value: "logDate" },
        { text: "Olay", value: "eventType" },

        { text: "IP Adresi", value: "ipAdress", sortable: false },
        { text: "İşletim Sistemi ve Tarayıcı", value: "operatingSystem", sortable: false }
      ],
      usersList:[],
    };
  },
  methods: {
  },
  created() {
  }
};
</script>